import { locale } from '@/utils/locale';

export const filterHandlerLocale = {
  filterBy: locale('academypass.filter.filterBy'),
  subjects: locale('academypass.filter.subjects'),
  searchByCourseName: locale('academypass.filter.searchByCourseName'),
  clearFilters: locale('academypass.filter.clearFilters'),
  multiSelectLabel: locale('academypass.filter.multiSelectLabel'),
};
